"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduxStore = exports.ReduxStore = exports.C2SEvent = void 0;
var C2SReducer_1 = require("./C2SReducer");
var EventBus_1 = require("../../api/EventBus");
exports.C2SEvent = EventBus_1.EventBus;
var ReduxStore = /** @class */ (function () {
    function ReduxStore() {
        // tslint:disable-next-line:no-any
        this.storeState = undefined;
        this.reducers = [];
        // tslint:disable-next-line:no-any
        this.subscriptions = [];
        this.createStore = this.createStore.bind(this);
        this.subscribe = this.subscribe.bind(this);
    }
    ReduxStore.prototype.store = function () {
        return ReduxStore.instance;
    };
    // tslint:disable-next-line:no-any
    ReduxStore.prototype.createStore = function (reducer, predefinedState, enhancer) {
        if (typeof (predefinedState) === 'function') {
            enhancer = predefinedState;
            predefinedState = undefined;
        }
        /* extras */
        if (enhancer) {
            return enhancer(this.createStore)(reducer, predefinedState);
        }
        this.reducers.push(reducer);
        this.dispatch({ type: '@@redux/INIT' });
        ReduxStore.instance = this;
        return this;
    };
    ReduxStore.prototype.registerReducers = function (reducr) {
        this.reducers.push(reducr);
    };
    ReduxStore.prototype.dispatch = function (action) {
        this.runReducers(action);
        for (var _i = 0, _a = this.subscriptions; _i < _a.length; _i++) {
            var subcription = _a[_i];
            subcription(action);
        }
    };
    ReduxStore.prototype.runReducers = function (action) {
        for (var _i = 0, _a = this.reducers; _i < _a.length; _i++) {
            var reduce = _a[_i];
            var tempState = reduce(this.storeState, action);
            this.storeState = __assign(__assign({}, this.storeState), tempState);
        }
    };
    ReduxStore.prototype.getState = function () {
        return this.storeState;
    };
    ReduxStore.prototype.subscribe = function (callback) {
        this.subscriptions.push(callback);
    };
    return ReduxStore;
}());
exports.ReduxStore = ReduxStore;
// tslint:disable-next-line:no-any
exports.reduxStore = new ReduxStore().createStore(C2SReducer_1.appReducer, 
// tslint:disable-next-line:no-any
window.__REDUX_DEVTOOLS_EXTENSION__
    // tslint:disable-next-line:no-any
    && window.__REDUX_DEVTOOLS_EXTENSION__());
//# sourceMappingURL=C2SEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/C2S/C2SEvent.js
// module id = 818
// module chunks = 8